import axios from 'axios';

const API_DEV_URL = 'https://api-avnfr.faview.ai/hoban/admin';

export const apiAWS = axios.create({
  baseURL: API_DEV_URL,
  xsrfHeaderName: 'X-CSRFToken',
  withCredentials: true,
});

export const spaceAPI = {
  // Resom Forest
  getSpacesResom: (header: object) =>
    apiAWS.get('/resom/space/get-spaces', { headers: header }),
  getSpaceResom: (header: object) =>
    apiAWS.get('/resom/space/get-space', { headers: header }),
  createSpaceResom: (header: object) =>
    apiAWS.post('/resom/space/create', {}, { headers: header }),
  updateSpaceResom: (header: object, body: object) =>
    apiAWS.post('/resom/space/update', body, { headers: header }),
  uploadSpaceResomImage: (header: object, body: object) =>
    apiAWS.post('/resom/space/img/upload/', body, { headers: header }),
  deleteSpaceResom: (header: object, body: object) =>
    apiAWS.post('/resom/space/delete', body, { headers: header }),

  // Resom Event
  getEventsResom: (header: object) =>
    apiAWS.get('/resom/event/get-events', { headers: header }),
  getEventResom: (header: object) =>
    apiAWS.get('/resom/event/get-event', { headers: header }),
  createEventResom: (header: object) =>
    apiAWS.post('/resom/event/create', {}, { headers: header }),
  updateEventResom: (header: object, body: object) =>
    apiAWS.post('/resom/event/update', body, { headers: header }),
  uploadEventResomImage: (header: object, body: object) =>
    apiAWS.post('/resom/event/img/upload/', body, { headers: header }),
  deleteEventResom: (header: object, body: object) =>
    apiAWS.post('/resom/event/delete', body, { headers: header }),

  // Resom User
  getUsersResom: (header: object) =>
    apiAWS.get('/resom/user/get-users', { headers: header }),

  // Avnfr-GG
  getSpacesAvnfrGG: (header: object) =>
    apiAWS.get('/avnfrgg/get-spaces', { headers: header }),
  getStatisticsAvnfrGG: (header: object) =>
    apiAWS.get('/avnfrgg/amplitude/load-data', { headers: header }),
  getSpaceAvnfrGG: (header: object) =>
    apiAWS.get('/avnfrgg/get-space', { headers: header }),
  updateSpaceAvnfrGG: (header: object, body: object) =>
    apiAWS.post('/avnfrgg/update', body, { headers: header }),
};

// Mauna API
const maunaAPI = axios.create({
  baseURL: 'https://api-mauna.faview.ai/admin',
  xsrfHeaderName: 'X-CSRFToken',
  withCredentials: true,
});

export const maunaSpaceAPI = {
  getSpaces: (header: object) =>
    maunaAPI.get('/get-spaces', { headers: header }),
  getSpace: (header: object) => maunaAPI.get('/get-space', { headers: header }),
  updateSpace: (header: object, body: object) =>
    maunaAPI.post('/update-space', body, { headers: header }),
  getUsers: (header: object) => maunaAPI.get('/get-users', { headers: header }),
  uploadImage: (sid: string, file: File) => {
    const formData = new FormData();
    formData.append('sid', sid);
    formData.append('file', file);
    return maunaAPI.post('/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getStatistics: (header: object) =>
    maunaAPI.get('/amplitude/load-data', { headers: header }),
};

export const maunaMissionAPI = {
  getMissions: (header: object) =>
    maunaAPI.get('/mission/get-missions', { headers: header }),
  getRewards: (header: object) =>
    maunaAPI.get('/mission/get-rewards', { headers: header }),
  updateMission: (header: object, body: object) =>
    maunaAPI.post('/mission/update', body, { headers: header }),
};

export const maunaRewardAPI = {
  getRewards: (header: object) =>
    maunaAPI.get('/reward/get-rewards', { headers: header }),
  updateReward: (header: object, body: object) =>
    maunaAPI.post('/reward/update', body, { headers: header }),
};

// Daekyo (Midas) API ///////////////////////////////////////////////////////////////////////////////////////
const daekyoAPI = axios.create({
  baseURL: 'https://api-daekyo.faview.ai/admin',
  xsrfHeaderName: 'X-CSRFToken',
  withCredentials: true,
});

const daekyoEventAPI = axios.create({
  baseURL: 'https://api-daekyo.faview.ai/event',
  xsrfHeaderName: 'X-CSRFToken',
  withCredentials: true,
});

export const daekyoSpaceAPI = {
  getSpaces: (header: object) =>
    daekyoAPI.get('/get-spaces', { headers: header }),
  getSpace: (header: object) =>
    daekyoAPI.get('/get-space', { headers: header }),
  updateSpace: (header: object, body: object) =>
    daekyoAPI.post('/update-space', body, { headers: header }),
  getUsers: (header: object) =>
    daekyoAPI.get('/get-users', { headers: header }),
  uploadImage: (sid: string, file: File) => {
    const formData = new FormData();
    formData.append('sid', sid);
    formData.append('file', file);
    return daekyoAPI.post('/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getStatistics: (header: object) =>
    daekyoAPI.get('/amplitude/load-data', { headers: header }),
};

export const daekyoEventAPIs = {
  getEvents: (header: object) =>
    daekyoAPI.get('/get-events', { headers: header }),
  crawlData: (body: object) => daekyoEventAPI.post('/crawl-data', body),
};
